import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useIsMobile } from '../../hooks/useIsMobile'
import { LoginModal } from './LoginModal'

export const AuthModalHost: React.FC = () => {
  // Disable automatic sign-in modal - users should sign in through the login page only
  return null
}



